import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e08765a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt--20 mb--20 ml--20 mr--20 m-font-size"
}
const _hoisted_2 = {
  key: 1,
  class: "complain-modal__form"
}
const _hoisted_3 = {
  key: 2,
  class: "items-in-column gap--0 complain-modal__reasons"
}
const _hoisted_4 = { class: "complain-modal__reasons-item" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "pb--17" }

import { computed, Ref, ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ErrorsType } from '@/types';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { useAppStore } from '@/store/modules/app';
import { useOfferCardsStore } from '@/store/modules/offerCards';

type FormDataType = {
  message: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ComplainModal',
  props: {
    showModal: { type: Boolean },
    entityId: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const complainReasons = computed(() => {
  return useAppStore().complaint_types;
});

const formData: Ref<FormDataType> = ref({
  message: undefined,
});

const clearFormData = () => {
  v$.value.$reset();
  formData.value.message = undefined;
};
const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  message: { required },
};
const v$ = useVuelidate<FormDataType>(rules, formData);
const errors: Ref<ErrorsType> = ref({});
const loading: Ref<boolean> = ref(false);
const complainType: Ref<number | undefined> = ref(undefined);
const showDescriptionForm = ref(false);
const sendMessage: Ref<string | undefined> = ref(undefined);

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};
const formSubmit = async () => {
  if (v$.value.$invalid || !complainType.value) {
    v$.value?.$touch();
    validationErrorsHandler();

    return;
  }

  loading.value = true;
  const preparedFormData = {
    entity_id: props.entityId,
    type: complainType.value,
    message: formData.value.message,
  };

  try {
    const res = await useOfferCardsStore().sendComplain(preparedFormData);

    if (res) {
      clearFormData();
      sendMessage.value = 'Жалоба успешно отправлена';
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

const chooseReason = (reasonId: string) => {
  complainType.value = +reasonId;
  showDescriptionForm.value = true;
};

const closeModal = () => {
  showDescriptionForm.value = false;
  sendMessage.value = undefined;
  clearFormData();
  emit('close');
};

return (_ctx: any,_cache: any) => {
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "hide-title": !!sendMessage.value,
    "show-modal": _ctx.showModal,
    "show-padding": false,
    "close-outside": "",
    title: "Пожаловаться",
    onClose: closeModal
  }, {
    content: _withCtx(() => [
      (sendMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(sendMessage.value), 1))
        : (showDescriptionForm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_base_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_base_textarea, {
                    modelValue: formData.value.message,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.message) = $event)),
                    error: errors.value.message,
                    invalid: !!errors.value.message,
                    height: "85",
                    label: "Комментарий",
                    textarea: "",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('message'))),
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.message)),
                    onInput: _unref(v$).message?.$touch
                  }, null, 8, ["modelValue", "error", "invalid", "onInput"])
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(complainReasons.value), (reason) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "complain-modal__reasons-btn",
                    onClick: ($event: any) => (chooseReason(reason[0]))
                  }, _toDisplayString(reason[1]), 9, _hoisted_5)
                ]))
              }), 256))
            ]))
    ]),
    btn: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        (showDescriptionForm.value && !sendMessage.value)
          ? (_openBlock(), _createBlock(_component_base_button, {
              key: 0,
              loading: loading.value,
              height: "40",
              text: "Отправить",
              width: "150",
              onClick: formSubmit
            }, null, 8, ["loading"]))
          : (_openBlock(), _createBlock(_component_base_button, {
              key: 1,
              height: "40",
              text: "Закрыть",
              width: "150",
              onClick: closeModal
            }))
      ])
    ]),
    _: 1
  }, 8, ["hide-title", "show-modal"]))
}
}

})